import { Component, Inject, inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { SharedService } from '@shared/services/shared.service';
import { IAddress } from 'app/models/address/address';
import { IInHomeCareLicense } from 'app/models/licenses/in-home-care/in-home-care-license';
import { AddressService } from 'app/services/address/address.service';
import { BranchOperationService } from 'app/services/license/branch-operation.service';

@Component({
  selector: 'app-export-in-home-care-license',
  templateUrl: './dialog-export-in-home-care-license.component.html',
  styleUrls: ['./dialog-export-in-home-care-license.component.scss']
})
export class ExportInHomeCareLicenseDialogComponent {
  @ViewChild('pdf') pdf: PDFExportComponent;

  public addresses: IAddress[] = [];
  public physicalAddress: IAddress = {
    id: 0,
    state: '',
    city: '',
    street: '',
    zip: '',
    county: '',
    archived: false,
    parentId: 0,
    addressTypes: []
  };
  public branchCities: string[] = [];
  public dialog = inject(MatDialog);
  public sharedService = inject(SharedService);
  public addressService = inject(AddressService);
  public branchService = inject(BranchOperationService);

  constructor(@Inject(MAT_DIALOG_DATA) public license: IInHomeCareLicense,
              private dialogRef: MatDialogRef<ExportInHomeCareLicenseDialogComponent>) { }

  ngOnInit(): void {
    this.getAddresses();
    this.getBranchCities();
  }

  getAddresses(): void {
    this.addressService.getAddresses(this.license.id, this.sharedService.inHomeCareLicense, false).subscribe({
      next: response => this.addresses = response,
      error: error => console.log('error getting addresses', error),
      complete: () => {
        this.physicalAddress = this.addresses.find(a => a.addressTypes.some(at => at.type === 'Physical'));
      }
    });
  }

  getBranchCities(): void {
    this.branchService.getBranchCities(this.license.id, this.sharedService.inHomeCareLicense).subscribe({
      next: response => this.branchCities = response,
      error: error => console.log('error getting branch cities', error)
    });
  }

  exportPDF(): void {
    this.pdf.saveAs(this.license.entityName + ' License.pdf');
  }

  close(): void {
    this.dialogRef.close();
  }
}
